import { Routes } from '@angular/router';

import { accessGuard, domainGuard, globalAdminGuard } from './core/auth/domain.guard';
import { Domain } from './core/auth/user-access.model';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () => import('./features/home/home.routes').then((module) => module.homeRoutes),
  },
  {
    path: 'health',
    data: { environmentDomain: 'OPERATIONS' satisfies Domain },
    canActivate: [accessGuard, domainGuard('OPERATIONS')],
    loadChildren: () =>
      import('./features/health/health.routes').then((module) => module.healthRoutes),
  },
  {
    path: 'manage-configurations',
    data: { environmentDomain: 'SASI' satisfies Domain },
    canActivate: [accessGuard, domainGuard('SASI')],
    loadChildren: () =>
      import('./features/manage-configurations/manage-configurations.routes').then(
        (module) => module.manageConfigurationsRoutes,
      ),
  },
  {
    path: 'display-pvms',
    data: { environmentDomain: 'SASI' satisfies Domain },
    canActivate: [accessGuard, domainGuard('SASI')],
    loadChildren: () =>
      import('./features/display-pvms/display-pvms.routes').then(
        (module) => module.displayPvmsRoutes,
      ),
  },
  {
    path: 'stocklocator',
    data: { environmentDomain: 'STOCKLOCATOR' satisfies Domain },
    canActivate: [accessGuard, domainGuard('STOCKLOCATOR')],
    loadChildren: () =>
      import('./features/stocklocator/stocklocator.routes').then(
        (module) => module.stocklocatorRoutes,
      ),
  },
  {
    path: 'user-management',
    data: { environmentDomain: 'USER_MANAGEMENT' satisfies Domain },
    canActivate: [accessGuard, globalAdminGuard],
    loadChildren: () =>
      import('./features/user-management/user-management.routes').then(
        (module) => module.userManagementRoutes,
      ),
  },
  {
    path: 'settings',
    canActivate: [accessGuard],
    loadChildren: () =>
      import('./features/settings/settings.routes').then((module) => module.settingsRoutes),
  },
  {
    path: 'help',
    canActivate: [accessGuard],
    loadChildren: () => import('./features/help/help.routes').then((module) => module.helpRoutes),
  },
  {
    path: 'account',
    canActivate: [accessGuard],
    loadChildren: () =>
      import('./features/account/account.routes').then((module) => module.accountRoutes),
  },
  {
    path: 'idp-access-denied',
    loadComponent: () =>
      import('./core/auth/idp-access-denied-page').then((module) => module.IdpAccessDeniedPage),
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./core/auth/access-status-page').then((module) => module.AccessStatusPage),
  },
  {
    path: 'access-unavailable',
    loadComponent: () =>
      import('./core/auth/access-status-page').then((module) => module.AccessStatusPage),
  },
  {
    path: 'excess-return',
    data: { environmentDomain: 'EXCESS_RETURN' satisfies Domain },
    canActivate: [accessGuard],
    loadChildren: () =>
      import('./features/excess-return/excess-return.routes').then(
        (module) => module.excessReturnRoutes,
      ),
  },
  {
    path: 'central-routing',
    data: { environmentDomain: 'CENTRAL_ROUTING' satisfies Domain },
    canActivate: [accessGuard, domainGuard('CENTRAL_ROUTING')],
    loadChildren: () =>
      import('./features/central-routing/central-routing.routes').then(
        (module) => module.centralRoutingRoutes,
      ),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
